import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

type SortOrder = (typeof dataGridSortDirection)[number];

export function useExamLocationListSearchParams() {
  const [
    { page, pageSize, sortOrder, locationName, provinceId },
    setExamLocationRequestListSearchParams,
  ] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('asc'),
    provinceId: parseAsString.withDefault(''),
    locationName: parseAsString.withDefault(''),
  });

  const changePageNumber = (page: number) => {
    setExamLocationRequestListSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setExamLocationRequestListSearchParams({ pageSize, page: 0 });
  };

  const changeSorting = ({ sortOrder }: { sortOrder: SortOrder | null }) => {
    setExamLocationRequestListSearchParams({ sortOrder, page: 0 });
  };

  const changeLocationName = (locationName: string | null) => {
    setExamLocationRequestListSearchParams({ locationName, page: 0 });
  };

  const changeProvinceId = (provinceId: string | null) => {
    setExamLocationRequestListSearchParams({ provinceId, page: 0 });
  };

  return [
    { page, pageSize, sortOrder, locationName, provinceId },
    {
      changePageNumber,
      changePageSize,
      changeSorting,
      changeLocationName,
      changeProvinceId,
    },
  ] as const;
}
